 export class LoginModel {
    constructor(
        public Email: string,
        public Password: string,
      ) {  }
}